import imagePickerResponseToLocalImage from '$tablet-app/src/app/images/imagePicker/imagePickerResponseToLocalImage';
import openCamera from '$tablet-app/src/app/images/imagePicker/openCamera';
import { LocalImage } from '$tablet-app/src/app/images/types';
import { AndroidOnly } from '$tablet-app/src/app/platform';
import { layout } from '$tablet-app/src/app/theme';
import React, { FC, useState } from 'react';
import { ModalProps, View } from 'react-native';
import styled from 'styled-components/native';
import NewButton from '../Button/NewButton';
import Dialog from '../Dialog';
import DialogBottomActions from '../Dialog/DialogBottomActions';
import Row from '../Row';
import SelectImageButton from '../SelectImageButton/SelectImageButton';
import Spacer from '../Spacer';
import { Text } from '../Text/Text';
import ImageDisplay from './ImageDisplay';

interface ImageFieldModalProps extends ModalProps {
  publicUrl?: string;
  onSubmit: (imageData: { url?: string; imageUpload?: LocalImage }) => void;
  onCancel: () => void;
}

interface ImageFieldState {
  input: string;
  uploadedImage?: LocalImage;
}

const ImageFieldModal: FC<ImageFieldModalProps> = ({
  publicUrl,
  onSubmit,
  ...props
}) => {
  const [state, setState] = useState<ImageFieldState>({
    input: publicUrl || '',
  });

  // const onInputChange = (e: any) => setState({ ...state, input: e.nativeEvent.text })
  const onImageSelect = (image: LocalImage) =>
    setState({ ...state, input: '', uploadedImage: image });

  const clearUploadedImage = () =>
    setState({ ...state, input: '', uploadedImage: undefined });

  const onSubmitClick = () => {
    onSubmit(
      state.uploadedImage
        ? { imageUpload: state.uploadedImage }
        : { url: state.input }
    );
  };

  const onPressTakePhoto = async () => {
    try {
      const image = imagePickerResponseToLocalImage(await openCamera());

      if (image) {
        onImageSelect(image);
      }
    } catch (ex) {}
  };

  return (
    <Dialog {...props}>
      <Content>
        <Heading variant="h3" weight="semibold">
          Image Selection
        </Heading>
        <Spacer height="32px" />
        {!state.uploadedImage ? (
          <Row alignItems="center" justifyContent="center">
            <SelectImageButton onSelect={onImageSelect} />
            <AndroidOnly>
              <Spacer width="16px" />

              <Text>Or</Text>

              <Spacer width="16px" />

              <NewButton icon="camera" onPress={onPressTakePhoto}>
                Take Photo
              </NewButton>
            </AndroidOnly>
          </Row>
        ) : (
          <View style={layout.centeredRow}>
            <ImageDisplay
              uri={state.uploadedImage.path}
              onClear={clearUploadedImage}
            />
          </View>
        )}
      </Content>
      <Spacer height="32px" />
      <DialogBottomActions>
        <Row>
          <NewButton variant="secondary" onPress={props.onCancel}>
            Cancel
          </NewButton>
          <Spacer width="16px" />
          <NewButton onPress={onSubmitClick}>Save</NewButton>
        </Row>
      </DialogBottomActions>
    </Dialog>
  );
};

const Content = styled.View`
  padding: 16px;
`;

const Heading = styled(Text)`
  text-align: center;
`;

export default ImageFieldModal;
